import { stagePointError } from '.'
import { AllStagesRule } from '../../../../../store/StageFile'

export const firstStageIsValid: AllStagesRule = (stages) => {
    // First stage must be numbered either: 121/122/123, 0, or 1
    let firstStage = stages.sort((a, b) => a.order - b.order)[0]
    if (firstStage && firstStage.number < 121 && firstStage.number != 0 && firstStage.number != 1) {
        return stagePointError(stages[0].stagePoints[0], `First stage must be numbered 123/122/121/0/1 - ${stages[0].number} is invalid`)
    }
}